export enum RegionEnum {
    PT = "PT",
    ES = "ES"
}

export enum RegionTLDEnum {
    TLD_PT = "pt",
    TLD_ES = "es"
}
